import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
// import ReactTable from 'react-table';
// import React from "react";
// import ReactDOM from "react-dom"
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1911() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    const [Borrow1911data, setBorrow1911data] = useState([]);
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)

    async function GetV1911() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1911", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow1911data(data.dataenum)
        // console.log(data)

    }

    const [Re1911yeardata, setRe1911yeardata] = React.useState([]);
    async function getR1911year() {
        const res = await fetch("/api/BorrowReports/getyear1911")
        const Re1911yeardata = await res.json()
        setRe1911yeardata(Re1911yeardata.dataenum)
        // console.log(Re1911yeardata)
    }




    useEffect(() => {
        GetV1911()
        getR1911year()
    }, [thYearSelected])
    /*  async function GetV1911() {
          const response1911 = await fetch("/api/BorrowReports/getV1911")
          const Borrow1911data = await response1911.json()
          setBorrow1911data(Borrow1911data.dataenum);
          // console.log(Borrow1911data)
      }*/

    var hidecolumn = false;
    var hidecolumn1 = false;
    var hidecolumn2 = false;
    var hidecolumn3 = false;
    var hidecolumn4 = false;
    var hidecolumn5 = false;
    var hidecolumn6 = false;
    var hidecolumn7 = false;
    var hidecolumn8 = false;
    var hidecolumn9 = false;
    var hidecolumn10 = false;
    var hidecolumn11 = false;

    let count1 = Borrow1911data.reduce(function (prev, current) {
        return current.count
    }, 0);
    var col = ((count1*2)+1);
    var hide1 = false;
    
    

    let sum1 = Borrow1911data.reduce(function (prev, current) {
        return current.month1
    }, 0);
     
    let sum2 = Borrow1911data.reduce(function (prev, current) {
        return current.month3
    }, 0);
    let sum3 = Borrow1911data.reduce(function (prev, current) {
        return current.month5
    }, 0);
    let sum4 = Borrow1911data.reduce(function (prev, current) {
        return current.month7
    }, 0);
    let sum5 = Borrow1911data.reduce(function (prev, current) {
        return current.month9
    }, 0);
    let sum6 = Borrow1911data.reduce(function (prev, current) {
        return current.month11
    }, 0);
    let sum7 = Borrow1911data.reduce(function (prev, current) {
        return current.month13
    }, 0);

    let sum8 = Borrow1911data.reduce(function (prev, current) {
        return current.month15
    }, 0);
    let sum9 = Borrow1911data.reduce(function (prev, current) {
        return current.month17
    }, 0);
    let sum10 = Borrow1911data.reduce(function (prev, current) {
        return current.month19
    }, 0);
    let sum11 = Borrow1911data.reduce(function (prev, current) {
        return current.month21
    }, 0);
    let sum12 = Borrow1911data.reduce(function (prev, current) {
        return current.month23
    }, 0);
    let sumall = (sum1+sum2+sum3+sum4+sum5+sum6+sum7+sum8+sum9+sum10+sum11+sum12);
    if(sumall == 0){
        var hide1 = true;
    }
    // console.log("1-"+sum1);
    // console.log("2-"+sum2);
    // console.log("3-"+sum3);
    // console.log("4-"+sum4);
    // console.log("5-"+sum5);
    // console.log("6-"+sum6);
    // console.log("7-"+sum7);
    // console.log("8-"+sum8);
    // console.log("9-"+sum9);
    // console.log("10-"+sum10);
    // console.log("11-"+sum11);
    // console.log("12-"+sum12);

    if (sum1 == 0 ) {
        var hidecolumn = true;  
    }
    if (sum2 == 0 ) {
        var hidecolumn1 = true;
    }
    if (sum3 == 0 ) {
        var hidecolumn2 = true;
    }
    if (sum4 == 0 ) {
        var hidecolumn3 = true;
    }
    if (sum5 == 0 ) {
        var hidecolumn4 = true;
    }
    if (sum6 == 0 ) {
        var hidecolumn5 = true;
    }
    if (sum7 == 0 ) {
        var hidecolumn6 = true;
    }
    if (sum8 == 0 ) {
        var hidecolumn7 = true;
    }
    if (sum9 == 0 ) {
        var hidecolumn8 = true;
    }
    if (sum10 == 0 ) {
        var hidecolumn9 = true;
    }
    if (sum11 == 0 ) {
        var hidecolumn10 = true;
    }
    if (sum12 == 0 ) {
        var hidecolumn11 = true;
    }

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ลำดับ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่คำขอกู้', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่สัญญา', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผู้กู้ยืม', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วงเงินขอกู้', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วงเงินอนุมัติ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ประชุมอนุเงินกู้ฯ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่โอนเงินให้หน่วยงานที่ทำ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ทำสัญญา', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'เริ่มชำระงวดแรก(เดือน)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันครบกำหนดหนดชำระเงินงวดสุดท้าย', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผ่อนชำระ(งวด)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ยอดเงินที่ต้องชำระ/งวด', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'การชำระหนี้', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เงินที่ต้องชำระ(บาท)', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หน่วยงาน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หมายเหตุ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, {}, {}, {}, {}, {}, {}, { text: 'วงเงิน', rowSpan: 2 , fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่', rowSpan: 2 , fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: ' ดอกเบี้ย', rowSpan: 2 , fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, { text: 'รวมชำระคืน (บาท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}],
    //     [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]];
    //     Borrow1911data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.borrowNumber, alignment: 'right' }, { text: item.contactNumber, alignment: 'right' }, { text: item.employee, alignment: 'right' }, { text: item.amountLimit, alignment: 'right' }, { text: item.amountApprove, alignment: 'right' }, { text: item.meetingDate, alignment: 'right' }, { text: item.transferDate, alignment: 'right' }, { text: item.amountApproveContract, alignment: 'right' }, { text: item.contactDate, alignment: 'right' }, { text: item.contactInterest, alignment: 'right' }, { text: item.firstPaymentMonth, alignment: 'right' }, { text: item.lastPaymentDate, alignment: 'right' }, { text: item.installment, alignment: 'right' }, { text: item.installmentAmount, alignment: 'right' }, { text: item.sum, alignment: 'right' }, { text: item.newBalance, alignment: 'right' }, { text: item.site, alignment: 'right' }, { text: item.remarkDirector, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'สรุปผลการอนุมัติให้กู้ยืมเงิน และการชำระเงินคืนเงินคืนกองทุนพัฒนาฝีมือแรงงาน จำแนกตามรายชื่อสถานประกอบกิจการ', bold: true, alignment: 'center', fontSize: 18 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['*', 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1911')
    // }


    return (
        <Container>
            <div>
                <div className='d-flex justify-content-center align-items-center'>
                    {/* <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ปีงบประมาณ พ.ศ.
                    </h3> */}
                    <span className='header-select-year mx-3'>ปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1911yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1911?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1911?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1911?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1911?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>

                <div className="report-wrapper">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="3">
                                ลำดับ
                            </th>
                            <th rowSpan="3">
                                เลขที่คำขอกู้
                            </th>
                            <th rowSpan="3">
                                เลขที่สัญญา
                            </th>
                            <th rowSpan="3">
                                ผู้กู้ยืม
                            </th>
                            <th rowSpan="3">
                                วงเงินขอกู้
                            </th>
                            <th rowSpan="3">
                                วงเงินอนุมัติ
                            </th>
                            <th rowSpan="3">
                                ประชุมอนุเงินกู้ฯ
                            </th>
                            <th rowSpan="3">
                                วันที่โอนเงินให้หน่วยงานที่ทำ
                            </th>
                            <th colSpan="3" className=' text-center'>
                                ทำสัญญา
                            </th>
                            <th rowSpan="3">
                                เริ่มชำระงวดแรก(เดือน)
                            </th>
                            <th rowSpan="3">
                                วันครบกำหนดหนดชำระเงินงวดสุดท้าย
                            </th>
                            <th rowSpan="3">
                                ผ่อนชำระ(งวด)
                            </th>
                            <th rowSpan="3">
                                ยอดเงินที่ต้องชำระ/งวด
                            </th>
                            <th colSpan={col} className=' text-center' hidden={hide1}>
                                การชำระเงิน
                            </th>
                            <th rowSpan="3">
                                เงินที่ต้องชำระ(บาท)
                            </th>
                            <th rowSpan="3">
                                หน่วยงาน
                            </th>
                            <th rowSpan="3">
                                หมายเหตุ
                            </th>
                            
                        </tr>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                วงเงิน
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วันที่
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn}>
                                ม.ค. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn1}>
                                ก.พ. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn2}>
                                มี.ค. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn3}>
                                เม.ย. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn4}>
                                พ.ค. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn5}>
                                มิ.ย. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn6}>
                                ก.ค. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn7}>
                                ส.ค. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn8}>
                                ก.ย. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn9}>
                                ต.ค. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn10}>
                                พ.ย. {thYearSelected}
                            </th>
                            <th colSpan="2" className=' text-center' hidden={hidecolumn11}>
                                ธ.ค. {thYearSelected}
                            </th>
                            <th rowSpan="2" className='text-center' hidden={hide1}>
                                รวมชำระคืน(บาท)
                            </th>
                        </tr>
                        <tr>
                            <th className='text-center' hidden={hidecolumn}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn1}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn1}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn2}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn2}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn3}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn3}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn4}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn4}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn5}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn5}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn6}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn6}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn7}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn7}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn8}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn8}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn9}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn9}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn10}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn10}>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center' hidden={hidecolumn11}>
                                เงินต้น
                            </th>
                            <th className='text-center' hidden={hidecolumn11}>
                                ดอกเบี้ย
                            </th>
                        </tr>
                    </thead>
                    <tbody> {Borrow1911data.map((item, i) => (
                        <tr key={i}>
                            <th scope="row" className='text-center'>
                                {i + 1}
                            </th>
                            <td className='text-end'>
                                {item.borrowNumber}
                            </td>
                            <td className='text-end'>
                                {item.contactNumber}
                            </td>
                            <td className='text-end'>
                                {item.employee}
                            </td>
                            <td className='text-end'>
                                {item.amountLimit}
                            </td>
                            <td className='text-end'>
                                {item.amountApprove}
                            </td>
                            <td className='text-end'>
                                {item.meetingDate}
                            </td>
                            <td className='text-end'>
                                {item.transferDate}
                            </td>
                            <td className='text-end'>
                                {item.amountApproveContract}
                            </td>
                            <td className='text-end'>
                                {item.contactDate}
                            </td>
                            <td className='text-end'>
                                {item.contactInterest}
                            </td>
                            <td className='text-end'>
                                {item.firstPaymentMonth}
                            </td>
                            <td className='text-end'>
                                {item.lastPaymentDate}
                            </td>
                            <td className='text-end'>
                                {item.installment}
                            </td>
                            <td className='text-end'>
                                {item.installmentAmount}
                            </td>
                            <td className='text-end' hidden={hidecolumn}>
                                {item.month1}
                            </td>
                            <td className='text-end' hidden={hidecolumn}>
                                {item.month2}
                            </td>
                            <td className='text-end' hidden={hidecolumn1}>
                                {item.month3}
                            </td>
                            <td className='text-end' hidden={hidecolumn1}>
                                {item.month4}
                            </td>
                            <td className='text-end' hidden={hidecolumn2}>
                                {item.month5}
                            </td>
                            <td className='text-end' hidden={hidecolumn2}>
                                {item.month6}
                            </td>
                            <td className='text-end' hidden={hidecolumn3}>
                                {item.month7}
                            </td>
                            <td className='text-end' hidden={hidecolumn3}>
                                {item.month8}
                            </td>
                            <td className='text-end' hidden={hidecolumn4}>
                                {item.month9}
                            </td>
                            <td className='text-end' hidden={hidecolumn4}>
                                {item.month10}
                            </td>
                            <td className='text-end'  hidden={hidecolumn5}>
                                {item.month11}
                            </td>
                            <td className='text-end' hidden={hidecolumn5}>
                                {item.month12}
                            </td>
                            <td className='text-end' hidden={hidecolumn6}>
                                {item.month13}
                            </td>
                            <td className='text-end' hidden={hidecolumn6}>
                                {item.month14}
                            </td>
                            <td className='text-end' hidden={hidecolumn7}>
                                {item.month15}
                            </td>
                            <td className='text-end' hidden={hidecolumn7}>
                                {item.month16}
                            </td>
                            <td className='text-end' hidden={hidecolumn8}>
                                {item.month17}
                            </td>
                            <td className='text-end' hidden={hidecolumn8}>
                                {item.month18}
                            </td>
                            <td className='text-end' hidden={hidecolumn9}>
                                {item.month19}
                            </td>
                            <td className='text-end' hidden={hidecolumn9}>
                                {item.month20}
                            </td>
                            <td className='text-end' hidden={hidecolumn10}>
                                {item.month21}
                            </td>
                            <td className='text-end' hidden={hidecolumn10}>
                                {item.month22}
                            </td>
                            <td className='text-end' hidden={hidecolumn11}>
                                {item.month23}
                            </td>
                            <td className='text-end' hidden={hidecolumn11}>
                                {item.month24}
                            </td>
                            <td className='text-end'hidden={hide1}>
                                {item.sum}
                            </td>
                                <td className='text-end'>
                                {item.newBalance}
                            </td>
                            <td className='text-end'>
                                {item.site}
                            </td>
                            <td className='text-end'>
                                {item.remarkDirector}
                            </td>
                            
                        </tr>
                    ))}
                    </tbody>
                </Table>
                </div>


            </div>

        </Container>
    );


}